import { Alert, Box, Button, TextField } from '@mui/material';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AuthPageLayout from './AuthPageLayout';
import { PASSWORD_MIN_LENGTH } from './authConstants';
import { resetPasswordWithToken } from './LoginUtils';

export default function ResetPassword() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token');
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        setError(null);
        if (password !== confirm) {
            setError('Passwords do not match');
            return;
        }
        setSubmitting(true);
        try {
            const result = await resetPasswordWithToken({ token, password });
            setSuccess(result.message);
        } catch (err) {
            setError(err.message);
        } finally {
            setSubmitting(false);
        }
    }

    if (!token) {
        return (
            <AuthPageLayout title="Reset your password">
                <Alert severity="error">Reset link is invalid.</Alert>
            </AuthPageLayout>
        );
    }

    return (
        <AuthPageLayout
            title="Choose a new password"
            footerLink={{ to: '/mycases', label: 'Back to sign in' }}
        >
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
            {!success && (
                <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <TextField
                        label="New password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        fullWidth
                        helperText={`At least ${PASSWORD_MIN_LENGTH} characters`}
                    />
                    <TextField
                        label="Confirm password"
                        type="password"
                        value={confirm}
                        onChange={(e) => setConfirm(e.target.value)}
                        required
                        fullWidth
                    />
                    <Button type="submit" variant="contained" disabled={submitting}>
                        {submitting ? 'Updating…' : 'Update password'}
                    </Button>
                </Box>
            )}
            {success && (
                <Button sx={{ mt: 2 }} variant="contained" onClick={() => navigate('/mycases')}>
                    Sign in
                </Button>
            )}
        </AuthPageLayout>
    );
}
